<template>
  <el-container class="data-detail-wrip">
    <header>
      <i class="iconfont icon-nav-platform"></i>
      {{reductionDetail.company_name}}
      <i class="iconfont icon-close" @click="closeDialog"></i>
    </header>
    <div class="tab-box">
      <div class="tab-item" :class="(tabType == 0)?'active':''" @click="dtlChange(0)"><span>客户资料</span></div>
      <div class="tab-item" :class="(tabType == 1)?'active':''" @click="dtlChange(1)"><span>操作记录</span></div>
    </div>
    <div class="head" v-if="tabType == 0">
      <span>客户资料</span>
      <el-dropdown trigger="click" @command="handleCommand" v-if="funAuth.includes(48)">
        <span class="el-dropdown-link">
          <i class="el-icon-arrow-down el-icon-more"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="1">删  除</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="head" v-if="tabType == 1">
      <span>操作记录</span>
    </div>
    <div class="content">
      <el-collapse v-model="activeNames" v-if="tabType == 0">
        <el-collapse-item name="1">
          <template slot="title">基本信息</template>
          <div class="form">
            <div class="item single">
              <span class="title">客户名称</span>
              <div class="item-content">{{reductionDetail.company_name}}</div>
            </div>
            <div class="item">
              <span class="title">客户姓名</span>
              <div class="item-content">{{reductionDetail.user_name}}</div>
            </div>
            <div class="item">
              <span class="title">联系电话</span>
              <div class="item-content">{{reductionDetail.phone}}</div>
            </div>
            <div class="item">
              <span class="title">增购项目</span>
              <div class="item-content" v-text="redfieldInit(reductionDetail.type)"></div>
            </div>
            <div class="item" v-if="reductionDetail.type == 1">
              <span class="title">减购坐席</span>
              <div class="item-content">{{reductionDetail.allow_number}}</div>
            </div>
            <div class="item" v-if="reductionDetail.type == 2">
              <span class="title">减购附件空间</span>
              <div class="item-content">{{reductionDetail.attachment_size}}GB</div>
            </div>
            <div class="item" v-if="reductionDetail.type == 3">
              <span class="title">减购数据上限</span>
              <div class="item-content">{{reductionDetail.data_size}}条</div>
            </div>
            <div class="item single">
              <span class="title">备注</span>
              <div class="item-content">{{reductionDetail.remark}}</div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">系统信息</template>
          <div class="form">
            <div class="item">
              <span class="title">创建人</span>
              <div class="item-content">{{reductionDetail.create_by}}</div>
            </div>
            <div class="item">
              <span class="title">创建时间</span>
              <div class="item-content">{{reductionDetail.create_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
            </div>
            <div class="item">
              <span class="title">修改人</span>
              <div class="item-content">{{reductionDetail.modify_by}}</div>
            </div>
            <div class="item">
              <span class="title">修改时间</span>
              <div class="item-content">{{reductionDetail.modify_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
      <div class="log-box" v-if="tabType == 1">
        <div class="log-item" v-for="(log, index) in logList" :key="index">
          <div class="line">
            <div class="circle"></div>
          </div>
          <div class="rihgt">
            <div class="time">{{log.datetime_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
            <div class="content">{{log.content}}</div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="提示" :visible.sync="dialogDelete" class="prompt-box" append-to-body>
      <i class="iconfont icon-prompt-box"></i>
      <div class="content">删除</div>
      <div class="note" v-if="reductionDetail.type == 1">删除后该公司的席位数会将减去的数据加上，确定要删除该减购吗？</div>
      <div class="note" v-if="reductionDetail.type == 2">删除后该公司的附件空间会将减去的数据加上，确定要删除该减购吗？</div>
      <div class="note" v-if="reductionDetail.type == 3">删除后该公司的数据总量会将减去的数据加上，确定要删除该减购吗？</div>
      <div class="prompt">你确定要删除该减购吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDelete = false">取 消</el-button>
        <el-button type="primary" @click="userDelete">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import mixin from '@/common/js/mixins.js'
import {HTTPServer} from '@/common/js/ajax.js'

export default {
  props: ['reduction'],
  mixins: [mixin],
  data () {
    return {
      reductionDetail: this.reduction,
      activeNames: ['1', '2', '3', '4'],
      moduleId: 4,
      tabType: 0,
      dialogDelete: false
    }
  },
  mounted () {
    this.queryFchBtnAuth(({moduleId: this.moduleId}))
  },
  methods: {
    // 关闭详情弹框
    closeDialog () {
      this.$bus.emit('closeAddDetailModal', true)
    },
    /** 详情导航切换 */
    dtlChange (type) {
      this.tabType = type
      if (type === 1) {
        this.queryRecordList({moduleType: this.moduleId, moduleId: this.reductionDetail.id})
      }
    },
    /** 点击菜单项触发的事件回调 */
    handleCommand (command) {
      if (command === '1') {
        this.dialogDelete = true
      }
    },
    /** 减购删除 */
    userDelete () {
      let title = this.redfieldInit(this.reductionDetail.type)
      let content = ''
      if (this.reductionDetail.type === 1) {
        content = this.reductionDetail.allow_number + '个'
      } else if (this.reductionDetail.type === 2) {
        content = this.reductionDetail.attachment_size + 'GB'
      } else if (this.reductionDetail.type === 3) {
        content = this.reductionDetail.data_size + '条'
      }
      HTTPServer.delReduction({'id': this.reductionDetail.id, 'accountId': this.reductionDetail.account_id, 'operatorRecord': title + content}, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.$bus.emit('query-reduction-list', true, true)
        this.$bus.emit('closeAddDetailModal', true)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/business/reduction-detail.vue